function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PredictionItem from '../PredictionItem/PredictionItem';
import emitter from '../../utils/emitter';
import { getNextPrediction, getPreviousPrediction } from '../../utils/predictions';
import './styles';

var PredictionList = /*#__PURE__*/function (_Component) {
  _inheritsLoose(PredictionList, _Component);

  function PredictionList(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.onDownArrow = _this.onDownArrow.bind(_assertThisInitialized(_this));
    _this.onUpArrow = _this.onUpArrow.bind(_assertThisInitialized(_this));
    _this.onFocus = _this.onFocus.bind(_assertThisInitialized(_this));
    _this.eventSubscriptions = [];

    _this.eventSubscriptions.push(emitter.addListener('focus', _this.onFocus));

    _this.eventSubscriptions.push(emitter.addListener('downArrow', _this.onDownArrow(getNextPrediction, emitter)));

    _this.eventSubscriptions.push(emitter.addListener('upArrow', _this.onUpArrow(getPreviousPrediction, emitter)));

    _this.state = {
      focusedId: null
    };
    return _this;
  }

  var _proto = PredictionList.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.eventSubscriptions.map(this.unsubscribe);
  };

  _proto.unsubscribe = function unsubscribe(subscription) {
    subscription.remove();
  };

  _proto.onFocus = function onFocus(id) {
    this.setState({
      focusedId: id
    });
  } // begin keyboard events
  ;

  _proto.onDownArrow = function onDownArrow(getNextPredictionImpl, emitterImpl) {
    var _this2 = this;

    return function () {
      var nextPrediction = getNextPredictionImpl(_this2.props.predictions, _this2.state.focusedId);

      if (nextPrediction) {
        emitterImpl.emit('focus', nextPrediction.__id__);
      }
    };
  };

  _proto.onUpArrow = function onUpArrow(getPreviousPredictionImpl, emitterImpl) {
    var _this3 = this;

    return function () {
      var previousPrediction = getPreviousPredictionImpl(_this3.props.predictions, _this3.state.focusedId);

      if (previousPrediction) {
        emitterImpl.emit('focus', previousPrediction.__id__);
      }
    };
  } // end keyboard events
  ;

  _proto.render = function render() {
    var _this$props = this.props,
        menuOpen = _this$props.menuOpen,
        predictions = _this$props.predictions,
        input = _this$props.input,
        useBolding = _this$props.useBolding;

    if (!predictions.length) {
      return '';
    }

    if (!menuOpen) {
      return '';
    }

    return /*#__PURE__*/React.createElement("ul", {
      className: "typeahead-prediction-list fds-field-select",
      role: "menu"
    }, predictions.map(function (p) {
      return /*#__PURE__*/React.createElement(PredictionItem, {
        key: p.__id__,
        menuOpen: menuOpen,
        prediction: p,
        input: input,
        useBolding: useBolding
      });
    }));
  };

  return PredictionList;
}(Component);

PredictionList.propTypes = {
  /** Flag to keep have the dropdown menu open from the right. */
  dropdownRight: PropTypes.bool,

  /** The input the user has typed so far */
  input: PropTypes.string,

  /** Flag to indicate if we should bold the partial match. */
  useBolding: PropTypes.bool.isRequired,

  /** Flag to indicate whether the menu is open. */
  // this is important for handling keyboard events
  menuOpen: PropTypes.bool,

  /** Array of predictions to present to the user */
  predictions: PropTypes.arrayOf(PropTypes.shape({
    __id__: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  }))
};
PredictionList.defaultProps = {
  predictions: []
};
export default PredictionList;
//# sourceMappingURL=PredictionList.js.map